import * as types from '../actions/actionTypes';

const initialState = {
    listDetails: {
        loading: false,
        success: true,
        data: {}
    },
    listRecipients: {
        loading: false,
        success: true,
        data: []
    },
    listExport: {
        loading: false,
        success: true,
        data: []
    },
    listUpdate: {
        loading: false,
        success: true
    },
    listSelection: {
        loading: false,
        success: true
    },
    listSubmission: {
        loading: false,
        success: true
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, {
                listDetails: {
                    ...initialState.listDetails,
                    loading: true
                }
            });
        case types.GET_EXTERNAL_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, {
                listDetails: action.response
            });

        case types.START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS:
            return Object.assign({}, state, {
                listRecipients: {
                    ...initialState.listRecipients,
                    loading: true
                }
            });
        case types.GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS:
            return Object.assign({}, state, {
                listRecipients: action.response
            });

        case types.START_EXPORT_EXTERNAL_CAMPAIGN_LIST:
            return Object.assign({}, state, {
                listExport: {
                    ...initialState.listExport,
                    loading: true
                }
            });
        case types.EXPORT_EXTERNAL_CAMPAIGN_LIST:
            return Object.assign({}, state, {
                listExport: action.response
            });

        case types.START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS:
            return Object.assign({}, state, {
                listUpdate: {
                    loading: true,
                    success: true
                }
            });
        case types.UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS:
            return Object.assign({}, state, {
                listUpdate: {
                    success: action.response.success,
                    loading: action.response.loading,
                    message: action.response.message
                }
            });

        case types.START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS:
            return Object.assign({}, state, {
                listSelection: {
                    loading: true,
                    success: true
                }
            });
        case types.SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS:
            return Object.assign({}, state, {
                listSelection: {
                    success: action.response.success,
                    loading: action.response.loading,
                    message: action.response.message
                }
            });

        case types.START_SUBMIT_EXTERNAL_CAMPAIGN_LIST:
            return Object.assign({}, state, {
                listSubmission: {
                    loading: true,
                    success: true
                }
            });
        case types.SUBMIT_EXTERNAL_CAMPAIGN_LIST:
            return Object.assign({}, state, {
                listSubmission: {
                    success: action.response.success,
                    loading: action.response.loading,
                    message: action.response.message
                }
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/ExternalCampaignListReducer.js